import { Box } from '@mui/material';

export const BodyLayout = ({ children }) => {
  return (
    <Box
      sx={{
        backgroundColor: '#ECEFF1',
        minHeight: '100vh',
        margin: 0,
        fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif`,
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
      }}
    >
      {children}
    </Box>
  );
};